module.exports = __webpack_public_path__ + "static/media/fetchUsers.334b70d0.graphql";